// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ezML","containerItemsCenter":"Skeleton_containerItemsCenter__2sv18"};